import { helper } from '@ember/component/helper';

import { streq } from 'rise-ui/utils/choice.js';

export default helper(function streqHelper(params) {
  return streq(...params);
});
